var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Social(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-social",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7276",
    "data-name": "Rectangle 7276",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "social-svgrepo-com",
    d: "M23.64,17.52a3.534,3.534,0,0,0-1.371-1.855,7.826,7.826,0,0,0,.081-1.371A8.943,8.943,0,0,0,16.7,5.985,3.176,3.176,0,0,0,13.556,3a3.311,3.311,0,0,0-3.227,2.985,8.943,8.943,0,0,0-5.647,8.309c0,.484.081.887.081,1.371A2.83,2.83,0,0,0,3.473,17.52,3.177,3.177,0,0,0,3.8,19.94a3.345,3.345,0,0,0,1.936,1.533,2.744,2.744,0,0,0,.807.081,4.711,4.711,0,0,0,1.452-.323,8.659,8.659,0,0,0,5.566,1.936,9.316,9.316,0,0,0,5.566-1.936,3.164,3.164,0,0,0,1.452.323,2.744,2.744,0,0,0,.807-.081,3.062,3.062,0,0,0,1.936-1.533A2.857,2.857,0,0,0,23.64,17.52ZM9.2,20.1l.484-.968a3.177,3.177,0,0,0-.323-2.42,3.345,3.345,0,0,0-1.936-1.533A4.962,4.962,0,0,0,6.377,15.1a2.744,2.744,0,0,1-.081-.807,7.332,7.332,0,0,1,4.356-6.7,3.344,3.344,0,0,0,2.9,1.855A3.2,3.2,0,0,0,16.46,7.6a7.165,7.165,0,0,1,4.356,6.7,2.744,2.744,0,0,1-.081.807,4.6,4.6,0,0,0-1.049.081,3.062,3.062,0,0,0-1.936,1.533,3.177,3.177,0,0,0-.323,2.42,2.726,2.726,0,0,0,.484.968,7.26,7.26,0,0,1-8.712,0Z",
    transform: "translate(-1.359 -1)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Social);
export default __webpack_public_path__ + "static/media/icon-24-social.f4e0e181fafe219a33230aaf279c1551.svg";
export { ForwardRef as ReactComponent };